import React, { useMemo, useState } from 'react';

const resolveInitialLocale = () => {
    if (typeof navigator === 'undefined') {
        return 'en';
    }
    return navigator.language && navigator.language.toLowerCase().startsWith('id') ? 'id' : 'en';
};

const LegalTextPage = ({ blocksByLocale, noticeByLocale }) => {
    const [locale, setLocale] = useState(resolveInitialLocale);
    const activeLocale = useMemo(() => (locale === 'id' ? 'id' : 'en'), [locale]);
    const blocks = blocksByLocale[activeLocale] || blocksByLocale.en || [];

    return (
        <div className="min-h-screen bg-gradient-to-b from-indigo-50 via-white to-indigo-100 py-10 px-4">
            <div className="mx-auto max-w-4xl rounded-2xl border border-indigo-100 bg-white p-6 md:p-8 shadow-lg">
                <div className="mb-6 flex flex-wrap items-center justify-between gap-3 border-b border-indigo-100 pb-4">
                    <p className="text-sm font-semibold text-indigo-600">
                        {activeLocale === 'id' ? 'Bahasa halaman' : 'Page language'}
                    </p>
                    <div className="inline-flex rounded-full border border-indigo-200 p-1">
                        <button
                            type="button"
                            className={`rounded-full px-4 py-1.5 text-sm font-semibold transition ${
                                activeLocale === 'id' ? 'bg-indigo-700 text-white' : 'text-indigo-700 hover:bg-indigo-50'
                            }`}
                            onClick={() => setLocale('id')}
                        >
                            Indonesia
                        </button>
                        <button
                            type="button"
                            className={`rounded-full px-4 py-1.5 text-sm font-semibold transition ${
                                activeLocale === 'en' ? 'bg-indigo-700 text-white' : 'text-indigo-700 hover:bg-indigo-50'
                            }`}
                            onClick={() => setLocale('en')}
                        >
                            English
                        </button>
                    </div>
                </div>
                <article className="legal-content">
                    {blocks.map((block, blockIndex) => {
                        if (block.type === 'heading') {
                            return <h1 key={`heading-${blockIndex}-${block.text}`}>{block.text}</h1>;
                        }

                        if (block.type === 'paragraph') {
                            return <p key={`paragraph-${blockIndex}-${block.text}`}>{block.text}</p>;
                        }

                        if (block.type === 'list') {
                            return (
                                <ul key={`list-${blockIndex}`}>
                                    {block.items.map((item, itemIndex) => (
                                        <li key={`item-${blockIndex}-${itemIndex}-${item}`}>{item}</li>
                                    ))}
                                </ul>
                            );
                        }

                        return null;
                    })}
                </article>
                {noticeByLocale && noticeByLocale[activeLocale] && (
                    <p className="mt-6 rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm leading-relaxed text-amber-800">
                        {noticeByLocale[activeLocale]}
                    </p>
                )}
            </div>
        </div>
    );
};

export default LegalTextPage;
